<template>
  <IframeCmp type="122" />
</template>

<script>
import IframeCmp from './cmp/IframeCmp';

export default {
  // 揽收已签收报表汇总
  name: 'SummaryOfPickedUpAndSignedReports',
  components: {
    IframeCmp
  },
  data() {
    return {

    };
  }
};
</script>
